module.exports = __webpack_public_path__ + "img/all.cd88596f.svg";